// Utilities
import createServiceAsyncThunk from "../../../utils/reduxUtils/createServiceAsyncThunk";
import createGenericSlice from "../../../utils/reduxUtils/createEntitySlice";

// Service
import { dashboardService } from "../../../Api/Services/DashboardService"; // Importing the dashboard service for API calls

// Constants
import { ACTION_NAMES, SLICE_NAMES } from "../../../constants/action";
import { ERROR_MESSAGES } from "../../../constants/error";
import { IAnnouncementServiceResponse } from "../../dashboard/types";

/**
 * Async thunk to fetch document types file.
 * Dispatches an API call to fetch documents types.
 */
export const fetchDocumentTypesAsyncThunk = createServiceAsyncThunk<
  IAnnouncementServiceResponse,
  { documentType: string }
>(
  ACTION_NAMES.FETCH_DOCUMENT_TYPES,
  ({ documentType }) => dashboardService.getDocumentTypes(documentType),
  ERROR_MESSAGES.DOCUMENT_TYPES_LIST_FAILURE
);

/**
 * Slice to manage the state for document types details.
 * Includes actions to clear errors and handle async states.
 */
export const documentTypeDetailsSlice = createGenericSlice<
  IAnnouncementServiceResponse,
  { documentType: string }
>(SLICE_NAMES.DOCUMENT_TYPES, fetchDocumentTypesAsyncThunk);

// Export the actions to be dispatched in components
export const { clearError: clearDocumentTypeErrorMessage } =
  documentTypeDetailsSlice.actions;

// Export the reducer function to be included in the Redux store
export default documentTypeDetailsSlice.reducer;
